module.exports = __webpack_public_path__ + "img/Deschapell.b8a27db9.jpeg";